// import { BottomImage } from "@/components/landing/bottom-image";
import { CTA } from "@/components/landing/cta";
import { Features } from "@/components/landing/features";
import { Hero } from "@/components/landing/hero";
import { Pricing } from "@/components/landing/pricing";
import { WhyInkriv } from "@/components/landing/why-inkriv";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_web/_layout/")({
  component: RouteComponent,
  ssr: true,
});

function RouteComponent() {
  return (
    <main>
      <Hero />
      <WhyInkriv />
      <CTA />
      <Features />
      <Pricing />
      <CTA />
    </main>
  );
}
